// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__71xI9","checkbox_box":"Checkbox_checkbox_box__sHQLR","checked":"Checkbox_checked__XxrrH","disabled":"Checkbox_disabled__h5VEk"};